import React, { useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { Tooltip, Icon } from 'antd';
import {
  EditorMenu,
  EditorContextToolbar,
  EditorSettings,
  ElementBackgroundColor,
  EditAreaToolbarContainer,
  VersionSection,
} from '../../../artboard/Toolbar/styles';
import { ShortMsgTextContext } from '../../../context/shortMessageContext';
import { versionIcon, testingIcon, envIcon } from '../../../images/svgIcons';
import SendToTestShortMsg from '../PublishCycle/SendToTestingEnvModal';
import { useTranslation } from 'react-i18next';
import { SHORT_MESSAGE_FORMATTING_TOOLBAR } from './translationValues';

/* This component is the top menu bar, used to format the text messages and contains env related optios 
  Child Components: 
    * SendToTestShortMsg
*/

const NAMESPACES = ['SHORT_MESSAGE_FORMATTING_TOOLBAR'];
const FormattingToolbar = props => {
  const { onVersionClick } = props;
  const { t } = useTranslation(NAMESPACES);
  const [showOptions, toggleOptions] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();
  const {
    focusedEditor,
    setIsDraft,
    isDraft,
    whatsappLength,
    messageLength,
    callLength,
    tempDetails,
  } = useContext(ShortMsgTextContext);

  const toolBarFormattingOptions = () => {
    return (
      <EditAreaToolbarContainer
        shortMsg={1}
        onKeyDown={e => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <div
          id={`toolbar-shortMsg`}
          style={{
            display: focusedEditor === 0 ? 'block' : 'none',
          }}
        >
          <span className="ql-formats ql-custom-tray">
            <button className="ql-bold custom-picker" />
            <button className="ql-italic custom-picker" />
            <button className="ql-underline custom-picker" />
            <Tooltip
              placement="top"
              title={t(
                SHORT_MESSAGE_FORMATTING_TOOLBAR.LINK_TOOLTIP.key,
                SHORT_MESSAGE_FORMATTING_TOOLBAR.LINK_TOOLTIP.value,
              )}
            >
              <button onClick={handleLink} className="ql-link custom-picker" />
            </Tooltip>
          </span>
        </div>
      </EditAreaToolbarContainer>
    );
  };

  const onPublish = async () => {
    setShowModal(true);
  };

  const handleLink = e => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <EditorMenu>
      <EditorContextToolbar id={'document-editor-toolbar'}>
        {toolBarFormattingOptions()}
      </EditorContextToolbar>
      <EditorSettings id={'document-editor-settings'}>
        <VersionSection className={showOptions ? 'show' : ''} show={showOptions}>
          {showOptions ? (
            <>
              <div className={'option'}>
                <div
                  className={'option versionSvg'}
                  onClick={() => {
                    onVersionClick();
                    toggleOptions(!showOptions);
                  }}
                >
                  <Tooltip
                    placement="left"
                    title={t(
                      SHORT_MESSAGE_FORMATTING_TOOLBAR.ENVS_TOOLTIP.key,
                      SHORT_MESSAGE_FORMATTING_TOOLBAR.ENVS_TOOLTIP.value,
                    )}
                  >
                    <Icon component={versionIcon} className="version" />
                  </Tooltip>
                  <p>
                    {t(
                      SHORT_MESSAGE_FORMATTING_TOOLBAR.ENVS_BUTTON.key,
                      SHORT_MESSAGE_FORMATTING_TOOLBAR.ENVS_BUTTON.value,
                    )}
                  </p>
                </div>
              </div>
              {(whatsappLength === 0 && messageLength === 0 && callLength == 0) || !isDraft ? (
                ''
              ) : (
                <div className={'option testingSvg'} onClick={onPublish}>
                  <Tooltip
                    placement="left"
                    title={t(
                      SHORT_MESSAGE_FORMATTING_TOOLBAR.SEND_FOR_TESTING_TOOLTIP.key,
                      SHORT_MESSAGE_FORMATTING_TOOLBAR.SEND_FOR_TESTING_TOOLTIP.value,
                    )}
                  >
                    <Icon className="testIcon" component={testingIcon} />
                  </Tooltip>
                  <p className="test">
                    {t(
                      SHORT_MESSAGE_FORMATTING_TOOLBAR.SEND_FOR_TESTING_BUTTON.key,
                      SHORT_MESSAGE_FORMATTING_TOOLBAR.SEND_FOR_TESTING_BUTTON.value,
                    )}
                  </p>
                </div>
              )}
            </>
          ) : (
            <>
              <div className={'option'}>
                <div className={'option versionSvg'}>
                  <Icon component={versionIcon} className="version" />
                  <p>
                    {' '}
                    {t(
                      SHORT_MESSAGE_FORMATTING_TOOLBAR.ENVS_BUTTON.key,
                      SHORT_MESSAGE_FORMATTING_TOOLBAR.ENVS_BUTTON.value,
                    )}
                  </p>
                </div>
              </div>
              {(whatsappLength === 0 && messageLength === 0 && callLength == 0) || !isDraft ? (
                ''
              ) : (
                <div className={'option testingSvg'}>
                  <Tooltip placement="left" title="">
                    <Icon className="testIcon" component={testingIcon} />
                  </Tooltip>
                  <p className="test">
                    {t(
                      SHORT_MESSAGE_FORMATTING_TOOLBAR.SEND_FOR_TESTING_BUTTON.key,
                      SHORT_MESSAGE_FORMATTING_TOOLBAR.SEND_FOR_TESTING_BUTTON.value,
                    )}
                  </p>
                </div>
              )}
            </>
          )}
        </VersionSection>
        {location?.pathname.includes('/shortMessageDesign/') && (
          <Tooltip
            placement="bottom"
            title={t(
              SHORT_MESSAGE_FORMATTING_TOOLBAR.VERSION_TOOLTIP.key,
              SHORT_MESSAGE_FORMATTING_TOOLBAR.VERSION_TOOLTIP.value,
            )}
          >
            <ElementBackgroundColor
              onClick={() => {
                toggleOptions(!showOptions);
              }}
              version={1}
            >
              <Icon component={envIcon} />
              {showOptions ? <Icon type="up" /> : <Icon type="down" />}
            </ElementBackgroundColor>
          </Tooltip>
        )}
        {showModal && (
          <SendToTestShortMsg
            isWhatsappEmpty={whatsappLength === 0}
            isSMSEmpty={messageLength === 0}
            isCallEmpty={callLength == 0}
            onCancel={() => setShowModal(false)}
            setIsDraft={e => setIsDraft(e)}
            templateId={tempDetails?.id}
          />
        )}
      </EditorSettings>
    </EditorMenu>
  );
};

export default React.memo(FormattingToolbar);
